export default __webpack_public_path__ + "static/media/grade-school-1.951da9f8.jpg";